module.exports = __webpack_public_path__ + "static/media/pic1.196440c1.jpg";